import {
    getClosestConfigurationFromRoundTable,
    getClosestConfigurationFromRectangleTable,
    getClosestConfigurationFromRow,
} from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getClosestConfiguration';
import calculateMatrixAxis from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/calculateMatrixAxis';
import getYOffsetForSeat from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getYOffsetForSeat';
import calculateRadialSeatAxis from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/calculateRadialSeatAxis';
import calculateRectangularSeatAxis from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/calculateRectangularSeatAxis';
import getSeatSize from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getSeatSize';

function resolveSeatTranslation(seat, seatCount) {
    let seatConfig = {};
    let spacing = {};

    if (seat.row) {
        const { row } = seat;
        ({ seatConfig } = getClosestConfigurationFromRow(row, 'seatConfig'));
        ({ spacing } = getClosestConfigurationFromRow(row, 'spacing'));
        let arc = false;
        if (seat.transformation && seat.transformation.translation) {
            ({ arc } = seat.transformation.translation);
        }
        return {
            x: calculateMatrixAxis(
                seat.index + 1,
                seatConfig.size,
                spacing.v,
            ),
            y: arc ? seat.transformation.translation.y : getYOffsetForSeat(seatConfig),
            arc,
        };
    }
    if (seat.roundTable) {
        const { roundTable: table } = seat;
        ({ seatConfig } = getClosestConfigurationFromRoundTable(table, 'seatConfig'));
        ({ spacing } = getClosestConfigurationFromRoundTable(table, 'spacing'));

        return {
            ...calculateRadialSeatAxis(
                seat.index + 1,
                table.compiled.size,
                table.gaps + seatCount,
                spacing.v,
                getSeatSize({ type: seatConfig.type, size: seatConfig.size })
            ),
            arc: false,
        };
    }
    if (seat.rectangleTable) {
        const { rectangleTable: table } = seat;
        ({ seatConfig } = getClosestConfigurationFromRectangleTable(table, 'seatConfig'));
        ({ spacing } = getClosestConfigurationFromRectangleTable(table, 'spacing'));
        return {
            ...calculateRectangularSeatAxis(
                seat.index + 1,
                {
                    width: table.compiled.width,
                    height: table.compiled.height,
                },
                {
                    north: table.seatsNorth,
                    south: table.seatsSouth,
                    east: table.seatsEast,
                    west: table.seatsWest,
                },
                spacing,
                seatConfig.size,
            ),
            arc: false,
        };
    }

    return { x: 0, y: 0 };
}

export default resolveSeatTranslation;
